/** The window's presets and the `datetime-local` conversions — shared by the
 *  picker and the page, which opens on {@link DEFAULT_PRESET}. */

/** Quick ways to fill the two inputs. Hours, so "today" and "last 6 hours" are
 *  expressible next to "90 days" in the same unit. */
export const PRESETS: { label: string; hours: number }[] = [
  { label: '6h', hours: 6 },
  { label: '24h', hours: 24 },
  { label: '7d', hours: 24 * 7 },
  { label: '30d', hours: 24 * 30 },
  { label: '90d', hours: 24 * 90 },
];

/** The window the page opens on. One value, read by both the page (which sets
 *  the range) and the picker (which lights its button) — they were two, and
 *  the page opened on 7 days with the 30d button lit. */
export const DEFAULT_PRESET = '7d';
export const DEFAULT_HOURS = PRESETS.find(p => p.label === DEFAULT_PRESET)!.hours;

/** `datetime-local` speaks local wall-clock with no zone, so it cannot take an
 *  ISO string. Both directions go through these. */
export function toInputValue(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    + `T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromInputValue(v: string): Date | null {
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function hoursAgo(h: number): Date {
  return new Date(Date.now() - h * 60 * 60 * 1000);
}
